import React from 'react'
import { Modal, Button } from 'antd'
import vipGuideStepsImg from '../../../../images/vip-guide-steps.png'

interface MobileVipGuideProps {
  open: boolean
  onClose: () => void
  onGoApp?: () => void
}

const MobileVipGuide: React.FC<MobileVipGuideProps> = ({
  open,
  onClose,
  onGoApp
}) => (
  <Modal
    open={open}
    title={null}
    footer={null}
    onCancel={onClose}
    centered
    width={400}
    styles={{ body: { padding: '32px 0 24px' } }}
    style={{ borderRadius: 2 }}
  >
    <h3
      style={{
        fontSize: 20,
        fontWeight: 600,
        color: '#1a1a1a',
        textAlign: 'center',
        margin: '0 0 8px'
      }}
    >
      手机端开通指引
    </h3>
    <p
      style={{
        fontSize: 13,
        color: '#666',
        textAlign: 'center',
        margin: '0 24px 20px'
      }}
    >
      请在手机上完成会员购买，即可解锁 Web 端全部功能
    </p>

    <div style={{ padding: '0 24px', marginBottom: 24 }}>
      <img
        src={vipGuideStepsImg}
        alt="开通步骤"
        style={{ width: '100%', display: 'block' }}
      />
    </div>

    <div style={{ padding: '0 24px' }}>
      <Button
        type="primary"
        onClick={() => {
          if (onGoApp) onGoApp()
          onClose()
        }}
        style={{
          width: '100%',
          height: 44,
          borderRadius: 4,
          fontSize: 16,
          fontWeight: 600,
          background: '#0070F4',
          borderColor: '#0070F4'
        }}
      >
        知道了
      </Button>
    </div>
  </Modal>
)

export default MobileVipGuide
